<div class="c-card c-content c-content--xxl u-wrapper" data-testid="symptom-interview" [attr.data-step-id]="vm.interview.currentSubStep" [attr.data-processing]="!!vm.isProcessing" [ngStyle]="vm.isProcessing && {'min-height': '200px'}">
	<p name="questionTextLabel" class="c-text c-text--spaced u-osb-md" *ngIf="vm.question.type==='group_multiple'">{{ vm.question.text }}</p>
	<form name="vm.form" #mainForm="ngForm" class="c-form" [ngSwitch]="vm.question.type">
		<fieldset *ngSwitchCase="'single'" class="c-content u-no-ph">
			<legend name="questionTextLabel" class="c-text u-osb-md@up-to-md">{{ vm.question.text }}</legend>
			<div class="c-form__group u-no-m" [ngClass]="{'c-form__group--error': vm.submitted && mainForm.invalid}">
				<div *ngFor="let option of vm.groupChoiceIds ; let $index=index ; let $last = last" [ngClass]="{'u-osb-sm': !$last}">
					<label class="c-radio">
						<input type="radio" name="question" [(ngModel)]="vm.evidence" #model1="ngModel" [value]="option" required>
						<span id="radioInputLabel{{$index}}">{{ vm.groupChoiceOptions[option] }}</span>
					</label>
				</div>
			</div>
		</fieldset>
		<fieldset *ngSwitchCase="'group_single'" class="c-content u-no-ph">
			<legend name="questionTextLabel" class="c-text u-osb-md@up-to-md">{{ vm.question.text }}</legend>
			<div class="c-form__group u-no-m" [ngClass]="{'c-form__group--error': vm.submitted && mainForm.invalid}">
				<div *ngFor="let item of vm.question.items ; let $index=index ; let $last = last" [ngClass]="{'u-osb-sm': !$last}">
					<label class="c-radio">
						<input type="radio" name="question" [(ngModel)]="vm.evidence" #model2="ngModel" [value]="item.id" required>
						<span id="radioInputLabel{{$index}}">{{ item.common_name || item.name }}</span>
					</label>
				</div>
			</div>
		</fieldset>
		<ng-container *ngSwitchCase="'group_multiple'">
			<fieldset class="c-content c-content--border-bottom u-no-ph" *ngFor="let item of vm.question.items ; let $parentIndex=index">
				<div class="o-grid o-grid--wrap">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-40@md-and-up u-no-p">
						<legend id="groupMultipleItemNameLabel" class="c-text u-osb-md@up-to-md">{{ item.common_name || item.name }}</legend>
					</div>
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-60@md-and-up u-no-p">
						<div class="c-form__group u-no-m" [ngClass]="{'c-form__group--error': vm.submitted && !vm.evidence[item.id]}">
							<div class="o-grid o-grid--wrap">
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p@up-to-md" *ngFor="let option of vm.groupChoiceIds ; let $index=index ; let $last = last" [ngClass]="{'u-osb-sm@up-to-md': !$last}">
									<label class="c-radio">
										<input type="radio" name="{{item.id}}" [(ngModel)]="vm.evidence[item.id]" #model3="ngModel" [value]="option" required>
										<span id="radioInputLabel{{$parentIndex}}-{{$index}}">{{ vm.groupChoiceOptions[option] }}</span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</fieldset>
		</ng-container>
	</form>
	<div class="o-grid u-ost-md">
		<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-pl">
			<button id="backButton" class="c-button c-button--link c-button--fit c-button--lg" type="button" (click)="vm.handleBack()">{{ 'Common.Back' | translate }}</button>
		</div>
		<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up u-no-pr">
			<button id="submitButton" class="c-button c-button--s1 c-button--fit c-button--lg" type="button" (click)="vm.handleSubmit(mainForm)">{{ 'Common.Next' | translate }}</button>
		</div>
	</div>
	<loader-overlay data-testid="symptom-interview-loading" *ngIf="vm.isProcessing"></loader-overlay>
	<div id="stateCheckElementForAutomatedTests" *ngIf="!vm.isProcessing"></div>
</div>
